import React from 'react';
import { useFormContext } from 'react-hook-form';
import i18n from '@/common/agent/i18n';
import Field from '@/common/view/form/Field';
import { LoginForm } from '../model/AuthTypes';
import PasswordInput from './PasswordInput';

const LoginPasswordFieldView: React.FC = () => {
  const { register, getFieldState, formState } = useFormContext<LoginForm>();
  const { error } = getFieldState('password', formState);
  return (
    <Field hideLabelSpacing error={error?.message}>
      <PasswordInput
        {...register('password')}
        placeholder={i18n.t('form.password.placeholder')}
        error={!!error}
      />
    </Field>
  );
};

export default LoginPasswordFieldView;
